import { useMutation } from "@tanstack/react-query";
import { loginWithSocialApiRequest } from "../../services";

export const useLoginWithSocialApi = () => {
  return useMutation({
    mutationFn: (accessToken: string) => loginWithSocialApiRequest(accessToken),
  });
};
